import type { IPaymentOptions } from '@/modules/perseo-billing/interfaces';

const CYBERSOURCE_ERROR = 'CHKPY30481';

const ERROR_CODES = {
  CONNECTION_ERROR: 'CHKPY210002'
};

const PAYMENT_METHODS: { [key in IPaymentOptions]: IPaymentOptions } = {
  EPAY_CENCOSUD_TCOM: 'EPAY_CENCOSUD_TCOM',
  EPAY_TCOM: 'EPAY_TCOM',
  WEBPAY: 'WEBPAY',
  GIFT_CARD: 'GIFT_CARD',
  CENCOPAY: 'CENCOPAY',
  CLUB: 'CLUB'
};

export { CYBERSOURCE_ERROR, ERROR_CODES, PAYMENT_METHODS };
